export default {
    index (params) {
        return axios.get('/api/variables', {params: params});
    },
    countries (params) {
        return axios.get('/api/variables/countries', {params: params});
    }
}
